import React, { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

interface IProps {
  confirmLabel: string;
  description: React.ReactNode;
  disabled?: boolean;
  isDestructive?: boolean;
  isLoading?: boolean;
  onConfirm: () => Promise<void>;
  title: string;
  trigger: React.ReactNode;
}

const NpsCampaignConfirmation: React.FC<IProps> = ({
  confirmLabel,
  description,
  disabled,
  isDestructive,
  isLoading,
  onConfirm,
  title,
  trigger,
}) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = async () => {
    try {
      await onConfirm();
      setOpen(false);
    } catch {}
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild disabled={disabled}>
        {trigger}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <Button
            variant={isDestructive ? 'destructive' : 'default'}
            loading={isLoading}
            onClick={handleConfirm}
          >
            {confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default NpsCampaignConfirmation;
